module.exports = __webpack_public_path__ + "media/images/author/author-12-2c9959c4700359b290136648755e8ddc.jpg";